





































































import { Vue, Component } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as activity from "../../_store/activity.module";
import * as auth from "../../_store/auth.module";
import { userUtils } from "../../_utils/userUtils";
import { bus } from "../../main";
import { Activities } from "../../_models/activities";
import CardTitle from "../../components/CardTitle.vue";
import { IscrizioneAzienda } from "../../_models/iscrizioneAzienda";
import { router } from "../../_router";
import * as data from "../../_store/data.module";
import * as temp from "../../_store/temp.module";
import WorkshopSubscriptionDialog from "../../components/Dialogs/WorkshopSubscriptionDialog.vue";

@Component({
  components: {
    CardTitle,
    WorkshopSubscriptionDialog
  }
})
export default class IscrizioniWorkshop extends Vue {
  private statusAlternanze: any[];
  private titleParams: object;
  private isComplete: boolean;

  private attivita: any;
  private istituti: any;

  constructor() {
    super();
    this.titleParams = {
      title: "Workshop Istituti",
      cols: "12",
      sm: "6",
      md: "5",
      lg: "5"
    };
    this.statusAlternanze = [];
    this.isComplete = false;

    this.attivita = [];
    this.istituti = [];
  }

  subscribeToActivity(
    idIstituto: any,
    idAttivita: any,
    statoPeriodoIscrizione: boolean,
    dataFineAttivita: string
  ) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var payload = {
      idAttivita: idAttivita,
      idAzienda: enterpriseInfo.idAzienda
    };
    var payload2 = {
      idAzienda: enterpriseInfo.idAzienda,
      idIstituto: idIstituto
    };
    var payload3 = {
      idAttivita: idAttivita,
      idAzienda: enterpriseInfo.idAzienda,
      idIstituto: idIstituto,
      statoPeriodoIscrizione: statoPeriodoIscrizione,
      dataFineAttivita: dataFineAttivita
    };
    this.isComplete = userUtils.checkEnterpriseInfo(enterpriseInfo);
    if (this.isComplete !== false) {
      data.dispatchRespDoc(this["$store"], payload2).then(response => {
        if (
          response.IdDocNominaResponsabile !== undefined &&
          response.IdDocNominaResponsabile !== null
        ) {
          if (response.StatoDocumento === 2) {
            bus.$emit("openWorkshopSubscription", payload3);
          } else {
            bus.$emit(
              "noDoc",
              "E' necessario attendere la verifica del documento per la nomina del responsabile trattamento dati"
            );
          }
        } else {
          bus.$emit(
            "noDoc",
            "E' necessario compilare il documento per la nomina del responsabile trattamento dati. Questo si può trovare nella sezione 'Amministrazione'/'Moduli'"
          );
        }
      });
    } else {
      bus.$emit("incompleteInfo");
    }
  }

  continueToWorkshop(
    idIstituto: any,
    idAttivita: number,
    idIscrizione: number,
    statoPeriodoIscrizione: boolean,
    dataFineAttivita: string
  ) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var payload = {
      idAttivita: idAttivita,
      idAzienda: enterpriseInfo.idAzienda
    };
    var payload2 = {
      idAzienda: enterpriseInfo.idAzienda,
      idIstituto: idIstituto
    };
    this.isComplete = userUtils.checkEnterpriseInfo(enterpriseInfo);
    if (this.isComplete !== false) {
      data.dispatchRespDoc(this["$store"], payload2).then(response => {
        if (
          response.IdDocNominaResponsabile !== undefined &&
          response.IdDocNominaResponsabile !== null
        ) {
          if (response.StatoDocumento === 2) {
            router.push({
              name: "workshopAzienda",
              params: {
                idIstituto: String(idIstituto),
                idAnnoScolastico: String(idAnnoScolastico),
                idIscrizioneAttivita: String(idIscrizione),
                statoPeriodoIscrizione: String(statoPeriodoIscrizione),
                dataFineAttivita: String(dataFineAttivita)
              }
            });
          } else {
            bus.$emit(
              "noDoc",
              "E' necessario attendere la verifica del documento per la nomina del responsabile trattamento dati"
            );
          }
        } else {
          bus.$emit(
            "noDoc",
            "E' necessario compilare il documento per la nomina del responsabile trattamento dati. Questo si può trovare nella sezione 'Amministrazione'/'Moduli'"
          );
        }
      });
    } else {
      bus.$emit("incompleteInfo");
    }
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetEnterpriseInfo(this["$store"])
          .then(() => {
            bus.$emit("loadMenu");
            var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
            var payload = {
              idAzienda: enterpriseInfo.idAzienda,
              idAnnoScolastico: idAnnoScolastico,
              activityType: "workshop"
            };
            var listaAttivitaIstituto: any[] = [];
            activity
              .dispatchGetAttivitaIstitutiInteresseAzienda(
                this["$store"],
                payload
              )
              .then(result => {
                result.forEach((element: any) => {
                  if (!this.istituti.includes(element.idIstituto)) {
                    this.istituti.push(element.idIstituto);
                  }
                });
                this.istituti.forEach((istituto: any) => {
                  var istitutoElem = {
                    idIstituto: 0,
                    denominazioneIstituto: "",
                    attivitaIstituto: []
                  };
                  istitutoElem.idIstituto = istituto;
                  result.forEach((attivita: any) => {
                    if (attivita.idIstituto === istitutoElem.idIstituto) {
                      istitutoElem.denominazioneIstituto =
                        attivita.denominazioneIstituto;
                      istitutoElem.attivitaIstituto.push({
                        //@ts-ignore
                        idIscrizione: attivita.idIscrizione,
                        //@ts-ignore
                        idAttivitaIstituto: attivita.idAttivitaIstituto,
                        //@ts-ignore
                        idAnnoScolastico: attivita.idAnnoScolastico,
                        //@ts-ignore
                        idAzienda: attivita.idAzienda,
                        //@ts-ignore
                        dataIscrizione: attivita.dataIscrizione,
                        //@ts-ignore
                        dataInizio: attivita.dataInizio,
                        //@ts-ignore
                        dataFine: attivita.dataFine,
                        //@ts-ignore
                        idTipoAttivita: attivita.idTipoAttivita,
                        //@ts-ignore
                        nomeAttivita: attivita.nomeAttivita,
                        //@ts-ignore
                        statoPeriodoIscrizione: attivita.statoPeriodoIscrizione
                      });
                    }
                  });
                  listaAttivitaIstituto.push(istitutoElem);
                });
                this.attivita = listaAttivitaIstituto;
              });
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }
}
